/** Shared wording for the same Italian civil-time decision on portal and mobile. */
const messages = {
  "it": [
    "Questo orario non esiste in Italia a causa del cambio dell’ora. Scegli un altro orario.",
    "Questo orario si ripete in Italia: scegli quale occorrenza intendi.",
    "Prima occorrenza (ora legale, UTC+02:00)",
    "Seconda occorrenza (ora solare, UTC+01:00)",
    "Occorrenza dell’orario"
  ],
  "es": [
    "Esta hora no existe en Italia por el cambio de horario. Elige otra hora.",
    "Esta hora se repite en Italia: elige a cuál te refieres.",
    "Primera ocurrencia (horario de verano, UTC+02:00)",
    "Segunda ocurrencia (horario de invierno, UTC+01:00)",
    "Ocurrencia de la hora"
  ],
  "en": [
    "This time does not exist in Italy because the clocks change. Choose another time.",
    "This time occurs twice in Italy: choose which occurrence you mean.",
    "First occurrence (summer time, UTC+02:00)",
    "Second occurrence (winter time, UTC+01:00)",
    "Time occurrence"
  ],
  "ro": [
    "Această oră nu există în Italia din cauza schimbării orei. Alege altă oră.",
    "Această oră se repetă în Italia: alege momentul dorit.",
    "Prima apariție (ora de vară, UTC+02:00)",
    "A doua apariție (ora de iarnă, UTC+01:00)",
    "Apariția orei"
  ],
  "ar": [
    "هذا الوقت غير موجود في إيطاليا بسبب تغيير الساعة. اختر وقتًا آخر.",
    "يتكرر هذا الوقت في إيطاليا: اختر المرة المقصودة.",
    "المرة الأولى (التوقيت الصيفي، UTC+02:00)",
    "المرة الثانية (التوقيت الشتوي، UTC+01:00)",
    "تكرار الوقت"
  ],
  "sq": [
    "Kjo orë nuk ekziston në Itali për shkak të ndryshimit të orës. Zgjidh një orë tjetër.",
    "Kjo orë përsëritet në Itali: zgjidh cilin rast nënkupton.",
    "Hera e parë (ora verore, UTC+02:00)",
    "Hera e dytë (ora dimërore, UTC+01:00)",
    "Rasti i orës"
  ],
  "uk": [
    "Цей час не існує в Італії через переведення годинника. Вибери інший час.",
    "Цей час в Італії повторюється: вибери потрібний випадок.",
    "Перший раз (літній час, UTC+02:00)",
    "Другий раз (зимовий час, UTC+01:00)",
    "Випадок часу"
  ],
  "fr": [
    "Cette heure n’existe pas en Italie à cause du changement d’heure. Choisissez une autre heure.",
    "Cette heure se répète en Italie : choisissez l’occurrence souhaitée.",
    "Première occurrence (heure d’été, UTC+02:00)",
    "Deuxième occurrence (heure d’hiver, UTC+01:00)",
    "Occurrence de l’heure"
  ],
  "zh": [
    "由于意大利时钟调整，此时间不存在。请选择其他时间。",
    "此时间在意大利出现两次：请选择您指的是哪一次。",
    "第一次（夏令时，UTC+02:00）",
    "第二次（冬令时，UTC+01:00）",
    "时间出现次数"
  ]
} as const;
const keys = ['time.nonexistent', 'time.ambiguous', 'time.earlier', 'time.later', 'time.occurrence'] as const;
export function romeTimeMessages(language: keyof typeof messages): Record<typeof keys[number], string> {
  return Object.fromEntries(keys.map((key, index) => [key, messages[language][index]])) as Record<typeof keys[number], string>;
}
